<div
  *ngIf="media"
  class="flex flex-col w-full justify-center p-2 gap-1 rounded border border-gray-400"
  [class]="media?.id === selectedMedia?.id && selectedMedia?.id ? 'bg-chathams-blue-400' : 'bg-gray-50'"
  [ngClass]="{
    'hidden': !media.selectedFile,
    'border-red-500 bg-red-50': media?.status === UploadStatus.error,
    'border-green-500 bg-green-50': media?.status === UploadStatus.success
  }">
  <div class="flex flex-row justify-between">
    <div
      class="flex flex-1 min-w-0 justify-center items-center gap-2"
      matTooltip="{{media?.name || media?.selectedFile?.name}}"
      matTooltipShowDelay="500">
      <div class="relative flex justify-center items-center w-[60px] h-[49px] rounded ">
        <img class="max-w-[60px] max-h-[49px] rounded" [src]="media?.selectedFile?.filePreview || media?.filePreview" />
        <app-icon
          *ngIf="media?.selectedFile?.format === MediaFormat.Video || media?.format === MediaFormat.Video"
          stroke="#fff"
          fill="#202020"
          iconName="play-file"
          size="sm"
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></app-icon>
      </div>
      <div class="flex flex-col flex-1 min-w-0 gap-1">
        <p class="text-gray-900 text-sm font-normal mb-0 truncate">{{media?.name || media?.selectedFile?.name}}</p>
        <p class="text-gray-800 text-xs font-normal leading-none mb-0">
          {{(media?.selectedFile?.fileSize || media?.fileSize) | filesize}}
        </p>
      </div>
    </div>
    <div class="flex items-center" *ngIf="!disableActions">
      <flow-button theme="light" *ngIf="media?.status !== UploadStatus.success && hasEditOutputSubscriber" (click)="editMedia(media)">
        <app-icon [ngStyle]="{cursor:'pointer'}" iconName="edit-pencil" size="md" stroke="#202020"></app-icon>
      </flow-button>
      <flow-button theme="light" *ngIf="media?.status === UploadStatus.error && hasReloadOutputSubscriber" (click)="reloadMedia(media, mediaIndex)">
        <app-icon [ngStyle]="{cursor:'pointer'}" iconName="refresh" size="md"fill="transparent" stroke="#202020"></app-icon>
      </flow-button>
      <flow-button theme="light" *ngIf="media?.status !== UploadStatus.success" (click)="removeMedia(media, mediaIndex)">
        <app-icon [ngStyle]="{cursor:'pointer'}" iconName="x" size="md" stroke="#202020"></app-icon>
      </flow-button>
    </div>
  </div>
  <div class="flex w-full" *ngIf="!hideLoader">
    <mat-progress-bar mode="determinate" [value]="media?.uploadProgress" class="w-full rounded"></mat-progress-bar>
  </div>
</div>
